import { computed, inject } from "vue";
import {
  checkRenderElementShowStatus,
  cssTextToJsObjWithBindData,
  filterConfigByScript,
} from "@/utils/renderBinding";
import { useResponsiveConfig } from "./useResponsiveConfig";
import { useStorefrontLogin } from "@/composables/useStorefrontLogin";
import { isStorefrontLoginEntry } from "@/utils/storefrontLogin";

function resolveConfigSource(configSource) {
  return typeof configSource === "function" ? configSource() : configSource;
}

export function useRenderConfig(configSource) {
  const { loginEnabled } = useStorefrontLogin();
  const getConfigJson = inject("getConfigJson", () => ({}));
  const getCommonConfigJson = inject("getCommonConfigJson", () => ({}));

  const commonConfig = computed(() => {
    return typeof getCommonConfigJson === "function" ? getCommonConfigJson() : {};
  });

  const pageConfig = computed(() => {
    return typeof getConfigJson === "function" ? getConfigJson() : {};
  });

  const bindData = computed(() => {
    return {
      ...(commonConfig.value?.bindData || {}),
      ...(pageConfig.value?.bindData || {}),
    };
  });

  const baseFilterConfig = computed(() => {
    const currentConfig = resolveConfigSource(configSource) || {};
    if (!currentConfig.filterScript) {
      return currentConfig;
    }
    return filterConfigByScript(
      currentConfig.filterScript,
      bindData.value,
      currentConfig,
    );
  });

  const { currentBreakpoint, resolvedConfig } = useResponsiveConfig(
    () => baseFilterConfig.value,
  );

  const filterConfig = computed(() => {
    return resolvedConfig.value || baseFilterConfig.value;
  });

  const showStatus = computed(() => {
    if (pageConfig.value?.isPreview || commonConfig.value?.isPreview) {
      return true;
    }
    if (filterConfig.value?.__responsiveHidden) {
      return false;
    }
    if (!loginEnabled.value && isStorefrontLoginEntry(filterConfig.value)) {
      return false;
    }
    return checkRenderElementShowStatus(bindData.value, filterConfig.value || {});
  });

  const setStyle = computed(() => {
    return cssTextToJsObjWithBindData(filterConfig.value?.styles || "", bindData.value);
  });

  return {
    bindData,
    filterConfig,
    setStyle,
    showStatus,
    currentBreakpoint,
  };
}
